import Time from './components/Time';

export default Time;
